import React, { Component } from 'react'
import Axios from 'axios';
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter'
import TopBar from '../topbar/topbar'
import right from '../assets/right1.png'
import left from '../assets/left.png'
import pageleft from '../assets/Home/pageleft.png'
import pagenoleft from '../assets/Home/pagenoleft.png'
import pagenoright from '../assets/Home/pagenoright.png'
import pageright from '../assets/Home/pageright.png'
import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
import togglearrow from '../assets/Home/togglearrow.png'
import { BASE } from '../api/api';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser'
import './project.css'
import { List } from 'react-content-loader';
import queryString from 'query-string'

import ReactPaginate from 'react-paginate';
require('dotenv').config()

// import 'bootstrap/dist/css/bootstrap.min.css';

const url = 'http://ifdb-be.tridz.in/'

class ProjectAll extends Component {

    constructor(props) {
        console.log("env found", process.env.HI)
        super(props);
        this.state = {
            size: 10,
            tab: 1,
            loadongoing: true,
            loadcompleted: true,
            loadsuspended: true,
            ongoingProjects: null,
            completedProjects: null,
            suspendedProjects: null,
            offsetongoing: 0,
            offsetcompleted: 0,
            offsetsuspended: 0,
            ongoingIncluded: [],
            completedIncluded: [],
            stage: this.props.match.params.type
        }
    }
    componentDidMount() {
        let page = this.props.match.params.page
        console.log("page detected", page)
        if (page) {
            console.log("page no is", page)
            if (this.state.stage == "ongoing")
                this.setState({
                    offsetongoing: (page * 10) - 10
                }, () => {
                    this.loadDetails()
                })
            else if (this.state.stage == "completed")
                this.setState({
                    offsetcompleted: (page * 10) - 10
                }, () => {
                    this.loadDetails()
                })
            else
                this.setState({
                    offsetsuspended: (page * 10) - 10
                }, () => {
                    this.loadDetails()
                })
        }
        else {
            this.loadDetails()
        }
        if (this.state.stage == "ongoing")
            this.setState({
                tab: 1
            })
        else if (this.state.stage == "completed")
            this.setState({
                tab: 2
            })
        else if (this.state.stage == "suspended")
            this.setState({
                tab: 3
            })
        else
            this.setState({
                tab: 1
            })

    }
    loadDetails() {
        Axios.get(`${BASE}jsonapi/node/faculty?include=field_author_faculty`)
            .then(item => {
                this.setState({
                    faculty: item.data.data
                })
            })
            .catch(err => {
                console.log("faculty not found", err)
            })
        Axios.get(`${BASE}jsonapi/node/project?include=field_grant_authoritys,field_lead_project__investigator,field_projectinvestigator,field_projects_deliverable&filter[field_project__status]=ongoing&page[offset]=${this.state.offsetongoing}&page[limit]=10&sort=-field_lead_cycles`)
            .then(data => {
                console.log("ongoing", data.data)
                this.setState({
                    ongoingProjects: data.data.data,
                    ongoingIncluded: data.data.included,
                    loadongoing: false,
                    ongoingcount: data.data.meta ? data.data.meta.count : ""
                })
                if (data.data.links.next) {
                    this.setState({
                        ongoingnext: true
                    })
                }
                else
                    this.setState({
                        ongoingnext: false
                    })
            })
            .catch(err => {
                console.log(err)
            })
        Axios.get(`${BASE}jsonapi/node/project?include=field_grant_authoritys,field_lead_project__investigator,field_projectinvestigator,field_projects_deliverable&filter[field_project__status]=completed&page[offset]=${this.state.offsetcompleted}&page[limit]=10&sort=-field_project__date`)
            .then(data => {
                console.log("completed", data.data)
                this.setState({
                    completedProjects: data.data.data,
                    completedIncluded: data.data.included,
                    loadcompleted: false,
                    completedcount: data.data.meta ? data.data.meta.count : ""
                })
                if (data.data.links.next) {
                    this.setState({
                        completednext: true
                    })
                }
                else
                    this.setState({
                        completednext: false
                    })
            })
            .catch(err => {
                console.log(err)
            })
        Axios.get(`${BASE}jsonapi/node/project?include=field_grant_authoritys,field_lead_project__investigator,field_projectinvestigator,field_projects_deliverable&filter[field_project__status]=suspended_withdrawn&page[offset]=${this.state.offsetsuspended}&page[limit]=10&sort=-field_lead_cycles`)
            .then(data => {
                console.log("suspended", data.data)
                this.setState({
                    suspendedProjects: data.data.data,
                    suspendedIncluded: data.data.included,
                    loadsuspended: false,
                    suspendedcount: data.data.meta ? data.data.meta.count : ""
                })
                if (data.data.links.next) {
                    this.setState({
                        suspendednext: true
                    })
                }
                else
                    this.setState({
                        suspendednext: false
                    })
            })
            .catch(err => {
                console.log(err)
            })
    }
    handlePageClickon = async (event) => {
        let selected = event.selected + 1
        let offset = (selected * 10) - 10
        console.log("event", offset)
        this.setState({
            offsetongoing: offset,
            ongoingProjects: null
        }, () => {
            this.loadDetails()
        })
    }
    handlePageClickco = async (event) => {
        let selected = event.selected + 1
        let offset = (selected * 10) - 10
        console.log("event", offset)
        this.setState({
            offsetcompleted: offset,
            completedProjects: null
        }, () => {
            this.loadDetails()
        })
    }
    handlePageClicksus = async (event) => {
        let selected = event.selected + 1
        let offset = (selected * 10) - 10
        console.log("event", offset)
        this.setState({
            offsetsuspended: offset,
            suspendedProjects: null
        }, () => {
            this.loadDetails()
        })
    }
    componentDidUpdate(prevProps, prevState) {
        console.log("prevState", prevState)
        let page = this.props.match.params.page
        if (this.state.offsetongoing !== prevState.offsetongoing || this.state.offsetcompleted !== prevState.offsetcompleted || this.state.offsetsuspended !== prevState.offsetsuspended) {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' })
            if (this.state.tab === 1) {
                let offset = (this.state.offsetongoing / 10) + 1

                this.props.history.push("/projects/ongoing/" + offset)
            }
            if (this.state.tab === 2) {
                let offset = (this.state.offsetcompleted / 10) + 1

                this.props.history.push("/projects/completed/" + offset)
            }
            if (this.state.tab === 3) {
                let offset = (this.state.offsetsuspended / 10) + 1

                this.props.history.push("/projects/suspended/" + offset)
            }
            this.loadDetails()
        }

        if (prevState.tab !== this.state.tab) {
            if (page) {
                if (this.state.tab === 1) {
                    this.props.history.push("/projects/ongoing/" + page)
                }
                if (this.state.tab === 2) {
                    this.props.history.push("/projects/completed/" + page)
                }
                if (this.state.tab === 3) {
                    this.props.history.push("/projects/suspended/" + page)
                }
            }
            else {
                if (this.state.tab === 1) {
                    this.props.history.push("/projects/ongoing")
                }
                if (this.state.tab === 2) {
                    this.props.history.push("/projects/completed")
                }
                if (this.state.tab === 3) {
                    this.props.history.push("/projects/suspended")
                }
            }
        }
    }
    render() {
        return (
            <div>
                <Header />
                <div className="title-banner">
                    <h1 className="heading-one bold white-text">Projects</h1>
                </div>
                <div className='container'>
                    <div className='subHeader'>
                        <div className='top-contents'>
                            <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /></Link><img className='rightarrow' src={crumbarrow} /><Link to='/projects' className='gray-text'>Research</Link><img className='rightarrow' src={crumbarrow} /><Link to='/projects' className='gray-text'>Projects</Link></div>
                            {/* <TopBar data={'data4'} /> */}
                        </div>
                    </div>
                    <p className='projectAll-sub body-two gray-text'>
                        <p>
                            Projects play an important and integral part in the academic journey at the College of Islamic Studies, Hamad Bin Khalifa University. Faculty members, researchers and students are encouraged to apply for project grants and fellowships to undertake new and challenging research to add to their own as well as to the institutional knowledge repertoire. These projects and grants range from a few months to a few years and more often than not, the academic output from these studies is in the form of a publication in a reputed journal, a chapter in a book, a manuscript with a reputed publisher and or actual policy recommendations and implementations.
                        </p>


                        <p>
                            The projects and supporting grants are both national as well as international and or a combination of both. Over the years, the CIS staff and students have received numerous such grants and undertaken multiple projects. The list below details out the projects undertaken along with their status.
                        </p>
                    </p>


                    <div className='projectall_container'>
                        {
                            <div className='projectsToggle'>
                                <div className='toggle-head heading-three bold blue-text'>
                                    Project Status
                                </div>
                                <div className="toggle-bar-one">
                                    <button className={this.state.tab === 1 ? 'blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 1, offsetcompleted: 0, offsetsuspended: 0 })}>Ongoing Projects&nbsp;{this.state.tab === 1 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                    <button className={this.state.tab === 2 ? 'blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 2, offsetongoing: 0, offsetsuspended: 0 })}>Completed Projects&nbsp;{this.state.tab === 2 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                    <button className={this.state.tab === 3 ? 'blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 3, offsetcompleted: 0, offsetongoing: 0 })}>Suspended /<br /> Withdrawn Projects&nbsp; {this.state.tab === 3 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                </div>
                            </div>
                        }
                        <div className='table-container'>
                            {this.state.completedProjects || this.state.ongoingProjects || this.state.suspendedProjects ?
                                <table className='newTable'>
                                    {
                                        this.state.tab === 2 ?
                                            <tr className='projectStatus-head'>
                                                <th className='lead'><p>Project Lead</p></th>
                                                <th className='title'><p> Project Title</p></th>
                                                <th className='cycle min-wids'><p> Grant Cycle</p></th>
                                                <th className='year min-wids'><p> Year</p></th>
                                            </tr> :
                                            <tr className='projectStatus-head ongoing'>
                                                <th className='lead'><p>Project Lead</p></th>
                                                <th className='title'><p> Project Title</p></th>
                                                <th className='cycle min-wids'><p> Grant Cycle</p></th>
                                            </tr>
                                    }
                                    {
                                        this.state.tab === 2 ?
                                            this.state.completedProjects ? this.state.completedProjects.map((item) => {
                                                let lead, faculty
                                                if (item.relationships.field_lead_project__investigator.data) {
                                                    lead = this.state.completedIncluded.filter(x => x.id === item.relationships.field_lead_project__investigator.data.id)
                                                    faculty = this.state.faculty ? this.state.faculty.filter(x => {
                                                        let id = x.relationships.field_author_faculty.data.filter(y => {
                                                            if (y.id == item.relationships.field_lead_project__investigator.data.id)
                                                                return y.id
                                                        })
                                                        if (id.length)
                                                            return id[0].id
                                                    }) : ""
                                                    console.log("lead", lead)
                                                }

                                                const date = new Date(item.attributes.field_project__date);
                                                return (
                                                    <tr className='projectDetails-row'>
                                                        <td className='lead'>
                                                            {item.relationships.field_lead_project__investigator.data ? faculty.length ? <Link to={`/faculty/${faculty[0].attributes.title}?nid=${faculty[0].attributes.drupal_internal__nid}`}> {lead[0].attributes.title ? lead[0].attributes.title : ""}</Link> : lead.length ? lead[0].attributes ? <p> {lead[0].attributes.title ? lead[0].attributes.title : ""}</p> : '' : "" : ""}
                                                        </td>
                                                        <td className="title"><Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`}>{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                        <td className='cycle min-wids'>{item.attributes.field_lead_cycles ? item.attributes.field_lead_cycles : ""}</td>
                                                        <td className='year min-wids'>{item.attributes.field_project__date ? date.getFullYear() : ""}</td>
                                                    </tr>
                                                )
                                            }) : "" : ""}
                                    {this.state.tab === 1 ? this.state.ongoingProjects ? this.state.ongoingProjects.map((item, ind) => {
                                        let lead, faculty
                                        if (item.relationships.field_lead_project__investigator.data) {
                                            lead = this.state.ongoingIncluded.filter(x => x.id === item.relationships.field_lead_project__investigator.data.id)
                                            faculty = this.state.faculty ? this.state.faculty.filter(x => {
                                                let id = x.relationships.field_author_faculty.data.filter(y => {
                                                    if (y.id == item.relationships.field_lead_project__investigator.data.id)
                                                        return y.id
                                                })
                                                if (id.length)
                                                    return id[0].id
                                            }) : ""
                                            console.log("lead", lead)
                                        }
                                        return (
                                            <tr className='projectDetails-row ongoing'>
                                                {/* <td>{item.lead.map((sub) => {
                                                        return (
                                                            <p>{sub}</p>
                                                        )
                                                    })}</td> */}
                                                <td className='lead'>
                                                    {item.relationships.field_lead_project__investigator.data ? faculty.length ? <Link to={`/faculty/${faculty[0].attributes.title}?nid=${faculty[0].attributes.drupal_internal__nid}`}> {lead[0].attributes.title ? lead[0].attributes.title : ""}</Link> : lead.length ? lead[0].attributes ? <p> {lead[0].attributes.title ? lead[0].attributes.title : ""}</p> : '' : "" : ""}
                                                </td>
                                                <td className='title'><Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`}>{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                <td className='cycle min-wids'>{item.attributes.field_lead_cycles ? item.attributes.field_lead_cycles : ""}</td>
                                            </tr>
                                        )
                                    }) : "" : ""}
                                    {this.state.tab === 3 ? this.state.suspendedProjects ? this.state.suspendedProjects.map((item) => {
                                        let lead, faculty
                                        if (item.relationships.field_lead_project__investigator.data) {
                                            lead = this.state.suspendedIncluded.filter(x => x.id === item.relationships.field_lead_project__investigator.data.id)
                                            faculty = this.state.faculty ? this.state.faculty.filter(x => {
                                                let id = x.relationships.field_author_faculty.data.filter(y => {
                                                    if (y.id == item.relationships.field_lead_project__investigator.data.id)
                                                        return y.id
                                                })
                                                if (id.length)
                                                    return id[0].id
                                            }) : ""
                                        }
                                        return (
                                            <tr className='projectDetails-row suspended'>
                                                {/* <td>{item.lead.map((sub) => {
                                                        return (
                                                            <p>{sub}</p>
                                                        )
                                                    })}</td> */}
                                                <td className='lead'>
                                                    {item.relationships.field_lead_project__investigator.data ? faculty.length ? <Link to={`/faculty/${faculty[0].attributes.title}?nid=${faculty[0].attributes.drupal_internal__nid}`}> {lead[0].attributes.title ? lead[0].attributes.title : ""}</Link> : lead.length ? lead[0].attributes ? <p> {lead[0].attributes.title ? lead[0].attributes.title : ""}</p> : '' : "" : ""}
                                                </td>
                                                <td className='title'><Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`}>{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                <td className='cycle min-wids'>{item.attributes.field_lead_cycles ? item.attributes.field_lead_cycles : ""}</td>
                                            </tr>
                                        )
                                    }) : "" : ""}
                                </table> : <List />}
                            {!this.state.ongoingProjects && this.state.tab == 1 ? <List /> : ""}
                            {!this.state.completedProjects && this.state.tab == 2 ? <List /> : ""}





                            {/*pagination*/}
                            {this.state.completedProjects || this.state.ongoingProjects || this.state.suspendedProjects ? this.state.tab == 1 ?
                                <div className='new-pagination'>
                                    <button disabled={this.state.offsetongoing === 0} onClick={() => this.setState({ offsetongoing: this.state.offsetongoing - 10 })} className='prev'>{this.state.offsetongoing === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetongoing ? (this.state.offsetongoing / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.ongoingcount ? Math.ceil(this.state.ongoingcount / 10) : 1}</div> <button disabled={!this.state.ongoingnext} onClick={() => this.setState({ offsetongoing: this.state.offsetongoing + 10 })} className='next'>{this.state.ongoingnext ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                                </div>
                                : "" : ""}
                            {this.state.completedProjects || this.state.ongoingProjects || this.state.suspendedProjects ? this.state.tab == 2 ? <div className='new-pagination'>
                                <button disabled={this.state.offsetcompleted === 0} onClick={() => this.setState({ offsetcompleted: this.state.offsetcompleted - 10 })} className='prev'>{this.state.offsetcompleted === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetcompleted ? (this.state.offsetcompleted / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.completedcount ? Math.ceil(this.state.completedcount / 10) : 1}</div> <button disabled={!this.state.completednext} onClick={() => this.setState({ offsetcompleted: this.state.offsetcompleted + 10 })} className='next'>{this.state.completednext ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                            </div> : "" : ""}
                            {this.state.completedProjects || this.state.ongoingProjects || this.state.loadsuspended ? this.state.tab == 3 ?
                                <div className='new-pagination'>
                                    <button disabled={this.state.offsetsuspended === 0} onClick={() => this.setState({ offsetsuspended: this.state.offsetsuspended - 10 })} className='prev'>{this.state.offsetsuspended === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetsuspended ? (this.state.offsetsuspended / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.ongoingcount ? Math.ceil(this.state.suspendedcount / 10) : 1}</div> <button disabled={!this.state.suspendednext} onClick={() => this.setState({ offsetsuspended: this.state.offsetsuspended + 10 })} className='next'>{this.state.suspendednext ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                                </div> : "" : ""}
                            {/* {this.state.completedProjects || this.state.ongoingProjects || this.state.suspendedProjects ? this.state.tab == 1 ?
                                <ReactPaginate
                                    nextLabel={<img src={right} />}
                                    onPageChange={this.handlePageClickon}
                                    // onClick={(e) => setNext(setoffseta(state.offseta + 15))}
                                    pageRangeDisplayed={3}
                                    marginPagesDisplayed={2}
                                    pageCount={this.state.ongoingcount ? Math.ceil(this.state.ongoingcount / 10) : 1}
                                    previousLabel={<img src={left} />}
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    activeLinkClassName="activePage"
                                    renderOnZeroPageCount={null}
                                />
                                : "" : ""}
                            {this.state.completedProjects || this.state.ongoingProjects || this.state.suspendedProjects ? this.state.tab == 2 ? <ReactPaginate
                                nextLabel={<img src={right} />}
                                onPageChange={this.handlePageClickco}
                                // onClick={(e) => setNext(setoffseta(state.offseta + 15))}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={2}
                                pageCount={this.state.completedcount ? Math.ceil(this.state.completedcount / 10) : 1}
                                previousLabel={<img src={left} />}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination"
                                activeClassName="active"
                                activeLinkClassName="activePage"
                                renderOnZeroPageCount={null}
                            />
                                : "" : ""}
                            {this.state.completedProjects || this.state.ongoingProjects || this.state.loadsuspended ? this.state.tab == 3 ? <ReactPaginate
                                nextLabel={<img src={right} />}
                                onPageChange={this.handlePageClicksus}
                                // onClick={(e) => setNext(setoffseta(state.offseta + 15))}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={2}
                                pageCount={this.state.suspendedcount ? Math.ceil(this.state.suspendedcount / 10) : 1}
                                previousLabel={<img src={left} />}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination"
                                activeClassName="active"
                                activeLinkClassName="activePage"
                                renderOnZeroPageCount={null}
                            />
                                : "" : ""} */}

                        </div>
                    </div>




                </div>
                <Footer />
            </div>
        )
    }
}
export default ProjectAll;